const CLOUDINARY_VERSION_SEGMENT = /^v\d+$/i;
const CLOUDINARY_UUID_SEGMENT =
  /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

function hasWebpDelivery(url: string): boolean {
  return /f_webp/i.test(url);
}

function isAlreadyWebpAsset(url: string): boolean {
  return /\.webp(\?|#|$)/i.test(url);
}

function looksLikeTransformSegment(segment: string): boolean {
  return segment.includes('_') || segment.includes(',');
}

function injectFormatAfterUploadPrefix(url: string, uploadPrefix: string): string | null {
  const prefixIndex = url.indexOf(uploadPrefix);
  if (prefixIndex === -1) {
    return null;
  }

  const before = url.slice(0, prefixIndex + uploadPrefix.length);
  let remainder = url.slice(prefixIndex + uploadPrefix.length);

  const queryIndex = remainder.search(/[?#]/);
  const suffix = queryIndex >= 0 ? remainder.slice(queryIndex) : '';
  if (queryIndex >= 0) {
    remainder = remainder.slice(0, queryIndex);
  }

  const segments = remainder.split('/').filter((segment) => segment.length > 0);
  if (segments.length === 0) {
    return null;
  }

  const [first, ...rest] = segments;
  let updated: string[];

  if (uploadPrefix === '/image/upload/') {
    if (CLOUDINARY_VERSION_SEGMENT.test(first)) {
      updated = ['f_webp', first, ...rest];
    } else if (looksLikeTransformSegment(first)) {
      updated = [`f_webp,${first}`, ...rest];
    } else {
      updated = ['f_webp', first, ...rest];
    }
  } else if (uploadPrefix === '/a/images/') {
    if (CLOUDINARY_UUID_SEGMENT.test(first)) {
      updated = ['f_webp', first, ...rest];
    } else if (looksLikeTransformSegment(first)) {
      updated = [`f_webp,${first}`, ...rest];
    } else {
      updated = ['f_webp', first, ...rest];
    }
  } else {
    return null;
  }

  return `${before}${updated.join('/')}${suffix}`;
}

/**
 * Requests webp delivery via Cloudinary/NMP transform params while keeping the
 * source file extension in the URL path (required for NMP S3 key resolution).
 *
 * Replaces the legacy `.jpg`/`.png` → `.webp` extension rewrite, which breaks
 * on NMP when backfilled objects are stored as `.jpg`/`.png`.
 */
export function applyWebpDelivery(url: string | undefined | null): string {
  if (!url || typeof url !== 'string') {
    return '';
  }

  if (hasWebpDelivery(url) || isAlreadyWebpAsset(url)) {
    return url;
  }

  const cloudinaryHost = injectFormatAfterUploadPrefix(url, '/image/upload/');
  if (cloudinaryHost) {
    return cloudinaryHost;
  }

  const nikeStatic = injectFormatAfterUploadPrefix(url, '/a/images/');
  if (nikeStatic) {
    return nikeStatic;
  }

  return url;
}
